module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('org-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Ponto de Controlo " + _vm._s(_vm.posto))])]), _vm._v(" "), (_vm.horaInicio) ? _c('div', [_c('p', [_vm._v("Hora de Início: "), _c('strong', [_vm._v(_vm._s(_vm.horaInicio))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "input-group col-md-3 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dorsal),
      expression: "dorsal"
    }],
    ref: "inputDorsal",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "[0-9]*",
      "placeholder": "dorsal...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.dorsal)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.regista($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dorsal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.dorsal || _vm.dorsal <= 0
    },
    on: {
      "click": function($event) {
        _vm.regista()
      }
    }
  }, [_vm._v("Regista")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.anula()
      }
    }
  }, [_vm._v("Anula")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Já passaram: "), _c('strong', [_vm._v(_vm._s(_vm.chegadas.atletas.conta))]), _vm._v(" atletas")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped tabela"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.chegadas.chegadas), function(chegada) {
    return _c('tr', {
      key: chegada.dorsal
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(chegada.dorsal))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(chegada.hora))])])
  }))])])]) : _vm._e(), _vm._v(" "), (!_vm.horaInicio) ? _c('div', [_c('p', [_vm._v("A prova ainda não iniciou....")])]) : _vm._e(), _vm._v(" "), _c('br')])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Dorsal")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Hora")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f1b34d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/org/Controlo2.vue
// module id = 263
// module chunks = 1